import { BYTES_IN_MB } from 'common/constants';
import { ChangeEvent } from 'react';


export const canUploadResults = (event: ChangeEvent<HTMLInputElement>): boolean => {
  if (!event.target.files?.length) return false;
  const bites = event.target.files[0].size;
  return (BYTES_IN_MB * 30) > bites;
};
